<template>
  <div class="space">
    <div class="base-search">
      <el-button type="success" @click="addEvent" style="background: #623AA2; border: none;">
        信息发布
      </el-button>
      <section style="margin: 0 10px;">
        <el-button type="primary" @click="downFn">下载模板</el-button>
        <el-button type="success" @click="exportFn">导入</el-button>
      </section>
      <el-button type="danger" icon="el-icon-delete" @click="deleteAll">批量删除</el-button>
      <el-input
        placeholder="请输入内容"
        v-model="searchValue"
        class="input-with-select"
        @keyup.enter.native="search"
        clearable
        @clear="search"
        style="width:240px"
      >
        <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
      </el-input>
      <label>信息类型:</label>
      <el-select
        style="width:180px"
        v-model="fieldValue"
        clearable
        placeholder="全部"
        @change="search"
        @clear="search"
      >
        <el-option
          v-for="item in levelOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </div>
    <div class="base-table">
      <el-table
        ref="multipleTable"
        :data="tableData"
        style="width: 100%"
        :header-cell-style="{ background: '#E5F3FE', color: '#623AA2' }"
        class="table"
        @selection-change="selectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>

        <el-table-column type="index" width="150" label="序号" align="center">
          <template slot-scope="scope">
            <span>{{ scope.$index + (current_page - 1) * per_page + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="信息类型" align="center">
          <template slot-scope="scope">
            <span>
              {{ GetMessageType(scope.row) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="信息" align="center" prop="message"></el-table-column>
        <el-table-column label="发布人" align="center" prop="publishPeople"></el-table-column>
        <el-table-column label="发布时间" align="center" prop="publishDate"></el-table-column>
        <el-table-column width="240px" align="center" label="操作">
          <template slot-scope="scope">
            <el-button class="mini_btn" type="text" @click="handleEdit(scope.row, true)">
              详情
            </el-button>
            <el-button class="mini_btn" type="text" @click="handleEdit(scope.row, false)">
              修改
            </el-button>
            <el-button class="mini_btn" type="text" @click="handleDelete(scope.row)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page.sync="current_page"
      :page-size="per_page"
      layout="total,prev, pager, next"
      :total="total"
      style="text-align:left;margin:20px 0"
    ></el-pagination>
    <el-dialog
      v-if="dialogFormVisible"
      @closed="is_submit = true"
      :title="Title"
      center
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      :append-to-body="true"
    >
      <el-form
        class="form"
        :model="ruleForm"
        ref="form"
        label-width="110px"
        label-position="right"
        :disabled="ruleForm.messageId ? true : false"
      >
        <el-form-item label="消息类型">
          <el-select
            v-model="ruleForm.messageType"
            placeholder="请选择消息类型"
            @change="messageTypeChange"
          >
            <el-option
              v-for="item in levelOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <form-one
        ref="toFrom"
        v-if="ruleForm.messageType === 1"
        :form-disabled="ruleForm.disabled"
        :message-id="ruleForm.messageId"
        :key="getKey(1)"
      ></form-one>
      <form-two
        ref="toFrom"
        v-else-if="ruleForm.messageType === 2"
        :form-disabled="ruleForm.disabled"
        :message-id="ruleForm.messageId"
        :dataType="1"
        :key="getKey(2)"
      ></form-two>
      <form-three
        ref="toFrom"
        v-else-if="ruleForm.messageType === 3"
        :form-disabled="ruleForm.disabled"
        :message-id="ruleForm.messageId"
        :dataType="2"
        :key="getKey(3)"
      ></form-three>
      <form-four
        ref="toFrom"
        v-else-if="ruleForm.messageType === 4"
        :form-disabled="ruleForm.disabled"
        :message-id="ruleForm.messageId"
        :dataType="3"
        :key="getKey(4)"
      ></form-four>
      <form-five
        ref="toFrom"
        v-else-if="ruleForm.messageType === 5"
        :form-disabled="ruleForm.disabled"
        :message-id="ruleForm.messageId"
        :key="getKey(5)"
      ></form-five>
      <form-six
        ref="toFrom"
        v-else-if="ruleForm.messageType === 6"
        :form-disabled="ruleForm.disabled"
        :message-id="ruleForm.messageId"
        :key="getKey(6)"
      ></form-six>
      <form-seven
        ref="toFrom"
        v-else-if="ruleForm.messageType === 7"
        :form-disabled="ruleForm.disabled"
        :message-id="ruleForm.messageId"
        :key="getKey(7)"
      ></form-seven>
      <form-eight
        ref="toFrom"
        v-else-if="ruleForm.messageType === 8"
        :form-disabled="ruleForm.disabled"
        :message-id="ruleForm.messageId"
        :key="getKey(8)"
      ></form-eight>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeForm()">取 消</el-button>
        <el-button v-if="!ruleForm.disabled" type="primary" @click="submitForm()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import Cookies from 'js-cookie';
import formOne from "./components/formOne.vue";
import formTwo from "./components/formTwo.vue";
import formThree from './components/formThree.vue';
import formFour from './components/formFour.vue';
import formFive from './components/formFive.vue';
import formSix from './components/formSix.vue';
import formSeven from "./components/formSeven.vue";
import formEight from "./components/formEight.vue";
import { FunDownload, ExportFn } from "@/utils/tool";

export default {
	components: {
		formOne,
		formTwo,
		formThree,
		formFour,
		formFive,
		formSix,
		formSeven,
		formEight

	},
	data() {
		return {
			loading: false,
			is_submit: true,
			fieldValue: "",
			total: 10,
			per_page: 10,
			current_page: 1,
			Title: "",
			searchValue: "",
			dialogFormVisible: false,
			tableData: [],
			levelOptions: [{
					value: 1,
					label: "新闻动态",
				},
				{
					value: 2,
					label: "投资机构",
				},
				{
					value: 3,
					label: "金融机构",
				},
				{
					value: 8,
					label: "担保机构",
				},
				{
					value: 4,
					label: "金融产品",
				},
				{
					value: 5,
					label: "科技项目库",
				},
				// {
				// 	value: 6,
				// 	label: "政策法规",
				// },
				{
					value: 7,
					label: "金融专家",
				}
			],
			ruleForm: {
				messageType: 1,
				messageId: null,
				disabled: false
			},
		};
	},
	created() {
		this.search();
	},
	methods: {
		getKey(val) {
			return Date();
		},
		GetMessageType(item) {
			if (item.messageTypeName) {
				return item.messageTypeName;
			} else {
				const message = this.levelOptions.find(detail => detail.value === item.messageType);
				if (message) {
					return message.label;
				}
			}
		},
		messageTypeChange(item) {
			console.log(item)
			const type = this.levelOptions.find(detail => detail.value === item)
			this.Title = type.label
		},
		 //   下载
    downFn() {
      FunDownload(
        `${process.env.BASE_URL}static/templates/科技项目库.xlsx`,
        "科技项目库.xlsx"
      );
    },
		async exportFn() {
      let res = await ExportFn(`${this.urlConfig.devUrl}apij2/admin-api/finance/finance-manager/import-excel`);
      if (res.code === 0) {
        this.$message.success(`数据导入成功`);
				this.search();
      } else {
        this.$message.warning(`数据导入失败`);
      }
    },
		getData(item) {
			const params = {
				page: this.current_page,
				pageSize: this.per_page,
				...item,
			}
			this.http.post(`${this.urlConfig.devUrl}apij2/admin-api/finance/finance-manager/page`, params).then((res) => {
				if (res.code == 0) {
					this.tableData = res.data.data;
					this.total = res.data.total;
					this.per_page = res.data.per_page;
					this.current_page = res.data.current_page * 1;
				}
			});
		},
		//城市选择
		citySelected(e) {
			this.ruleForm.address = e;
		},
		//富文本
		getQuillData(val) {
			this.ruleForm.introduction = val;
		},
		getQuillData1(val) {
			this.ruleForm.standard = val;
		},
		//新增
		addEvent() {
			this.dialogFormVisible = true;
			this.Title = "新闻动态";
			this.ruleForm = {
				messageType: 1,
				messageId: null,
				disabled: false
			};
		},
		//批量删除
		deleteAll() {
			if (this.deleteRow) {
				this.$confirm("此操作将批量删除, 是否继续?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
						center: true,
					})
					.then(() => {
						this.http.post(`${this.urlConfig.devUrl}apij2/admin-api/finance/finance-manager/delBatch`, {dels: this.deleteRow})
							.then((res) => {
								if (res.code == 0) {
									this.search();
									this.$message({
										type: "success",
										message: "删除成功",
									});

								} else {
									this.$message({
										message: "失败！",
										type: "error",
									});
								}
							});
					})
					.catch(() => {
						this.$message({
							type: "info",
							message: "已取消删除",
						});
					});
			} else {
				this.$message({
					type: "warning",
					message: "请选择删除的记录",
				});
			}
		},
		//搜索
		search() {
			this.getData({page: 1, keyword: this.searchValue, messageType: this.fieldValue});
		},
		//选择
		selectionChange(selection) {
			this.deleteRow = selection;
			// if (selection.length != 0) {
			// 	let arr = [];
			// 	selection.forEach((item) => {
			// 		arr.push(item.id);
			// 	});
			// 	this.deleteRow = arr.join(",");
			// }
		},
		//编辑
		handleEdit(row, status) {
			const item = this.levelOptions.find(detail => detail.value === row.messageType);
			this.Title = item.label;
			this.dialogFormVisible = true;
			this.ruleForm = {
				messageId: row.id,
				messageType: row.messageType,
				disabled: status
			}
		},
		//删除
		handleDelete(row) {
			this.$confirm("此操作将永久删除, 是否继续?", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
					center: true,
				})
				.then(() => {
					this.http.post(`${this.urlConfig.devUrl}apij2/admin-api/finance/finance-manager/delBatch`, {dels: [row]})
					  .then((res) => {
							if (res.code == 0) {
								this.search();
								this.$message({
									type: "success",
									message: "删除成功",
								});
							} else {
								this.$message({
									message: "失败！",
									type: "error",
								});
							}
						});
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: "已取消删除",
					});
				});
		},
		//翻页
		handleCurrentChange(e) {
			this.getData({page: e, keyword: this.searchValue, messageType: this.fieldValue})
		},
		//取消
		closeForm() {
			this.dialogFormVisible = false;
		},
		subData(item) {
			if(this.loading) return;
			this.loading = true;
      // item['dataType'] = item.id
      const url = this.getUrl(item.id);
			const params = JSON.parse(JSON.stringify(item));
			const userInfo = JSON.parse(Cookies.get('userInfo'));
			params.publisher = userInfo.id;
			params.publisherName = userInfo.username;
			item.publishedFlag = item.publishedFlag ? 1 : 0;
			// item.approvalStatus = 1
			this.http.post(url, item).then((res) => {
				this.loading = false;
					if (res.code == 0) {
						this.dialogFormVisible = false;
						this.search();
						this.$message({
							type: "success",
							message: item.id ? "修改成功" : "新增成功",
						});
					} else {
						this.is_submit = true;
					}
				}).catch(err => {
					this.is_submit = true;
					this.loading = false;
				});
		},
		getUrl(id) {
			let url = this.urlConfig.devUrl;
			switch (this.ruleForm.messageType) {
				case 1:
					url += 'apij2/admin-api/finance/news/'
					break;
				case 2:
				case 8:
				case 3:
					url += 'apij2/admin-api/finance/investment-firms/'
					break;
				case 4:
					url += 'apij2/admin-api/finance/product/'
					break;
				case 5:
					url += 'apij2/admin-api/finance/projects/'
					break;
				case 6:
					url += 'apij2/admin-api/finance/policy-regulation/'
					break;
				case 7:
					url += 'apij2/admin-api/finance/expert-talent/'
					break;
			}
			if (id) {
				url += 'update'
			} else {
				url += 'create'
			}
			return url;
		},
		//提交
		submitForm() {
			this.$refs.toFrom.parentHandleclick((valid) => {
				if(valid) {
					this.subData(valid)
				}
			});
		}
	},
};
</script>

<style scoped lang="scss">
.space {
  height: 100%;
  width: 100%;

  .base-search {
    width: 100%;
    text-align: left;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .el-select {
      margin: 0 15px;
    }

    /deep/.el-input--suffix {
      width: 100%;
    }

    .el-input {
      margin: 0 15px;
    }

    .date-picker {
      margin: 0 15px;

      .el-range-separator {
        width: auto;
      }
    }
  }

  .base-table {
    width: 100%;
    margin-top: 20px;
    border: 1px solid #eef1f6;
  }
}
</style>
